import { type ObjectValuesUnionType } from '../utils/typing';

export const MyMatchBetStatuses = Object.freeze({
  SUSPENDED: -1,
  INACTIVE: 0,
  ACTIVE: 1,
});
export type MyMatchBetStatus = ObjectValuesUnionType<typeof MyMatchBetStatuses>;

export type MyMatchFutureEntitiesBetState = {
  mmStatus?: MyMatchBetStatus;
  mmMultichoiceStatus?: MyMatchBetStatus;
};

export type MyMatchFutureEntitiesBets = {
  [betId: number]: MyMatchFutureEntitiesBetState;
};

export type MyMatchFutureEntitiesOutcomeState = {
  mmContradicting?: boolean; // -> est-ce que cet outcome entrainerait une contradiction s'il devait être selectionné ?
  mmOdds?: number | null; // -> cote mymatch de l'outcome | mmOdds === 1 -> on grise la cote
};

export type MyMatchFutureEntitiesFullOutcomeState = MyMatchFutureEntitiesOutcomeState & {
  multichoice?: MyMatchFutureEntitiesOutcomeState;
};

export type MyMatchFutureEntitiesOutcomes = {
  [outcomeId: number]: MyMatchFutureEntitiesFullOutcomeState;
};

export type MyMatchFutureEntities = {
  bets: MyMatchFutureEntitiesBets;
  outcomes: MyMatchFutureEntitiesOutcomes;
};

export type MyMatchState = {
  getFutureOddsIsLoadingMatchIds: Array<number>;
  myMatchModeMatchIds: Array<number>;
  futureEntities: MyMatchFutureEntities;
};
